import { Image, Menu } from "antd";
import { useCallback, useContext, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import Dash from "../../assets/images/side_nav/dash.svg";
import Invoice from "../../assets/images/side_nav/invoice.svg";
import Menumen from "../../assets/images/side_nav/menu-manage.svg";
import Order from "../../assets/images/side_nav/order.svg";
import User from "../../assets/images/side_nav/user.svg";
import AirlineIcon from "../../assets/images/side_nav/airplane.png";
import HotalsIcon from "../../assets/images/side_nav/hotel.png";
import BusIcon from "../../assets/images/side_nav/bus.png";
import HotelManagementLogo from "../../assets/images/hotal-management-logo.png";

import { AuthContext } from "../../context/AuthContext";
import lang from "../../helper/langHelper.js";
import DeleteModal from "../DeleteModal.js";

// Define menu items for Admin
const adminMenuItems = [

  {
    label: lang("Dashboard"),
    key: "Dashboard",
    path: "/dashboard",
    icon: Dash,
  },
  // {
  //   label: lang("Registration Card"),
  //   key: "registration-card",
  //   path: "/airline/registration-card",
  //   icon: Invoice,
  // },
  {
    label: lang("Airline Management"),
    key: "Airline Management",
    path: "/airline-management",
    icon: AirlineIcon,
  },
  {
    label: lang("Hotels"),
    key: "Hotel Management",
    path: "/hotel-management",
    icon: HotalsIcon,
  },
  {
    label: lang("Guest"),
    key: "Guest",
    path: "/admin/guest",
    icon: User,
  },
  // {
  //   label: lang("Agents"),
  //   key: "Agent Management",
  //   path: "/agent-management",
  //   icon: User,
  // },
  {
    label: lang("Bookings"),
    key: "Bookings",
    path: "/bookings",
    icon: Menumen,
  },
  // {
  //   label: lang("Send Notification"),
  //   key: "notifications/send",
  //   path: "/notifications/send",
  //   icon: Bell,
  // },
  // {
  //   label: lang("Notification History"),
  //   key: "notifications/history",
  //   path: "/notifications/history",
  //   icon: Bell,
  // },
  {
    label: lang("Bus Companies"),
    key: "Bus Company",
    path: "/bus-companies",
    icon: BusIcon,
  },
];

const hotelMenuItems = [
  {
    label: lang("Dashboard"),
    key: "dashboard",
    path: "/dashboard",
    icon: Dash,
  },
  {
    label: lang("Hotels"),
    key: "Hotel Management",
    path: "/hotel-management",
    icon: HotalsIcon,
  },
  // {
  //   label: lang("Agents"),
  //   key: "Agent Management",
  //   path: "/agent-management",
  //   icon: User,
  // },
  {
    label: lang("Bookings"),
    key: "Bookings",
    path: "/bookings",
    icon: Menumen,
  },
  // {
  //   label: lang("Bus Companies"),
  //   key: "Bus Company",
  //   path: "/bus-companies",
  //   icon: User,
  // },
];

const agentMenuItems = [
  {
    label: lang("Dashboard"),
    key: "agent-dashboard",
    path: "/agent-dashboard",
    icon: Dash,
  },

  {
    label: lang("Associated Hotels"),
    key: "agent-hotels",
    path: "/agent-hotels",
    icon: Menumen,
  },
  {
    label: lang("Booking Enquires"),
    key: "Booking Enquires",
    path: "/agent-booking-enquires",
    icon: Order,
  },
  {
    label: lang("Picked Bookings"),
    key: "agent-picked-bookings",
    path: "/agent-picked-bookings",
    icon: Invoice,
  },
];

const airlineMenuItems = [
  {
    label: lang("Dashboard"),
    key: "airline-dashboard",
    path: "/airline-dashboard",
    icon: Dash,
  },
  {
    label: lang("Registration Card"),
    key: "registration-card",
    path: "/airline/registration-card",
    icon: Invoice,
  },
  // {
  //   label: lang("Airlines Management"),
  //   key: "Airline Management",
  //   path: "/airline-management",
  //   icon: Menumen,
  // },
  {
    label: lang("Hotels"),
    key: "Hotel Management",
    path: "/hotel-management",
    icon: HotalsIcon,
  },
  {
    label: lang("Guest"),
    key: "Guest",
    path: "/admin/guest",
    icon: User,
  },
  {
    label: lang("Bookings"),
    key: "Bookings",
    path: "/bookings",
    icon: Menumen,
  },
];

const busMenuItems = [
  {
    label: lang("Dashboard"),
    key: "bus-dashboard",
    path: "/bus-dashboard",
    icon: Dash,
  },
  {
    label: lang("Daily Trip Reports"),
    key: "bus-reports",
    path: "/bus-reports",
    icon: Invoice,
  },
];

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const { userProfile, logout } = useContext(AuthContext);
  const [menuLinks, setMenuLinks] = useState(adminMenuItems); // Initialize with admin menu items
  const [menuMode, setMenuMode] = useState("vertical");

  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const storedRole = localStorage.getItem("authRole");
  const userType = userProfile?.userType || userProfile?.user_type;
  const activePanelLabel =
    userType === "HotelPartner" || storedRole === "hotel"
      ? "Hotel Panel"
      : userType === "Agent" || storedRole === "agent"
        ? "Agent Panel"
        : userType === "Airline" || storedRole === "airline"
          ? "Airline Panel"
          : userType === "bus_company" || storedRole === "bus"
            ? "Bus Company Panel"
            : "Admin Panel";

  const renderTitle = (item) => {
    return (
      <>
        <Image src={item.icon} preview={false} />
        <span className="label">{item.label}</span>
      </>
    );
  };

  useEffect(() => {
    const role = localStorage.getItem("authRole");
    const userType = userProfile?.userType || userProfile?.user_type;
    if (role === "hotel" || userType === "HotelPartner") {
      setMenuLinks(hotelMenuItems);
      return;
    }
    if (role === "agent" || userType === "Agent") {
      setMenuLinks(agentMenuItems);
      return;
    }
    if (role === "airline" || userType === "Airline") {
      setMenuLinks(airlineMenuItems);
      return;
    }
    if (role === "admin" || userType === "Super_Admin") {
      setMenuLinks(adminMenuItems);
      return;
    }
    if (role === "bus" || userType === "bus_company") {
      setMenuLinks(busMenuItems);
      return;
    }
    setMenuLinks(adminMenuItems);
  }, [userProfile]);

  const handleResize = useCallback(() => {
    if (window.innerWidth <= 768) {
      setMenuMode("inline");
    } else {
      setMenuMode("vertical");
    }
  }, []);

  useEffect(() => {
    // Ensure menu items are always set on mount
    if (menuLinks.length === 0) {
      const role = localStorage.getItem("authRole");
      if (role === "hotel") setMenuLinks(hotelMenuItems);
      else if (role === "agent") setMenuLinks(agentMenuItems);
      else if (role === "airline") setMenuLinks(airlineMenuItems);
      else if (role === "bus") setMenuLinks(busMenuItems);
      else setMenuLinks(adminMenuItems);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize, menuLinks.length]);

  return (
    <>
      <div className="brand-logo">
        <NavLink
          to={(localStorage.getItem("authRole") === "hotel" && "/dashboard") || (localStorage.getItem("authRole") === "agent" && "/agent-dashboard") || (localStorage.getItem("authRole") === "airline" && "/airline-dashboard") || "/dashboard"}
          className="imgOuter"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            justifyContent: "center",
            textDecoration: "none",
            color: "#1f2937",
            marginBottom: 10,
          }}
        >

          <img src={HotelManagementLogo} alt="logo" />
        </NavLink>
        <div
          style={{
            marginTop: 10,
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "6px 12px",
            borderRadius: 999,
            background: "#f8fafc",
            border: "1px solid #e5e7eb",
          }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: "#f59e0b",
              boxShadow: "0 0 0 3px rgba(245, 158, 11, 0.2)",
            }}
          />
          <span style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>
            Active: {activePanelLabel}
          </span>
        </div>
      </div>
      <Menu
        inlineCollapsed={false}
        mode={menuMode}
        className="sideNavMain"
        selectedKeys={[page]}
      >
        {(menuLinks && menuLinks.length > 0 ? menuLinks : adminMenuItems).map(
          (item) => {
            if (item.children) {
              return (
                <>
                  <Menu.SubMenu
                    key={item.key}
                    title={
                      <>
                        <span className="icon">
                          <Image src={item.icon} />
                        </span>
                        <span className="label">{item.label}</span>
                      </>
                    }
                  >
                    {item.children.map((child) => (
                      <Menu.Item key={child.key}>
                        <NavLink to={child.path}>{child.label}</NavLink>
                      </Menu.Item>
                    ))}
                  </Menu.SubMenu>
                </>
              );
            }

            return (
              <Menu.Item key={item.key}>
                <NavLink to={item.path}>{renderTitle(item)}</NavLink>
              </Menu.Item>
            );
          },
        )}
      </Menu>

      {isLogoutModalVisible && (
        <DeleteModal
          title="Logout"
          subtitle="Are you sure you want to log out of the application?"
          show={isLogoutModalVisible}
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={() => logout()}
          okText="Logout"
          dangerOk={false}
        />
      )}
    </>
  );
}

export default Sidenav;
